<template>
  <el-drawer
    :wrapperClosable="false"
    :visible.sync="visible"
    :size="$puhuoDialog == '3' ? '100%' : '1230px'"
    @close="closeHandle"
    :class="`edit-drawer ${activeName}`"
    id="prod-center-edit-dialog"
    >
    <div slot="title">
      <span style="color:#3e4144;font-size:18px;font-weight:700;">商品编辑</span>
      <span v-if="openSource === 'taskCenter' && !isCanEdit" style="color:red;font-size:14px;margin-left:10px;">已铺货裂变商品信息不支持编辑保存</span>
    </div>
    <div v-loading="saveLoading" element-loading-spinner="el-icon-loading" element-loading-custom-class="prod-custom-loading">
    <el-tabs
      v-model="actPlatformCategory"
      @tab-click="platformCategoryTabClick"
    >  
      <el-tab-pane
        v-for="c in platformCategoryList"
        :key="c"
        :name="c"
        :label="`${PLATFORM_CATEGORY[c].label}`"
        :disabled="disabledLlatformCategory(c)"
      >
        <div v-if="c === 'kj'" slot="label">
          {{PLATFORM_CATEGORY[c].label}}<el-tag type="warning" size="small" class="ml-5">限时试用</el-tag>
        </div>
        <el-tabs
          class="subTab"
          v-model="activeName"
          :before-leave="handleTabsBeforeLeave"
          @tab-click="handleClick"
        >  
          <!--减少其他不必要的渲染，只渲染当前tab下的平台 -->
          <el-tab-pane
            v-for="p in c === actPlatformCategory ? platformPaneList : []"
            :key="p"
            v-loading="loading[p]"
            element-loading-spinner="el-icon-loading"
            element-loading-custom-class="prod-custom-loading"
            :label="`${PLATFORM_NAMES[p]}资料`"
            :name="p">
            <template v-if="activeName === 'fxg'">
              <el-alert type="warning" show-icon style="margin-bottom: 10px;"> 
                <div style="color: #333">
                  抖音类目2.0已升级，店铺已开始使用新版类目。为保障您的商品上架体验，系统已将自动为您匹配并转换新版类目，如抖音资料，抖音铺货配置等，请您务必核实，确保归类正确。如遇到转换类目与预期不符，可手动调整。
              </div>
              </el-alert>
              <el-alert type="warning" show-icon style="margin-bottom: 10px;"> 
                <div style="color: #333">
                  抖音平台尺码表3.0升级改造已上线，增加尺码表基础，丰富规则。部分类目尺码表需进一步扩展补充信息后可使用，用户请及时调整受影响的尺码表信息，及尺码表配置信息，以免影响商品发布。
              </div>
              </el-alert>
            </template>
            <template v-if="activeName === 'fxg' && showCachedData && !hasSetCachedData">
              <el-alert type="warning" style="margin-bottom: 10px;"> 
                <div slot="title"> 是否恢复上一次操作内容？<el-button type="text" @click="handleSetCachedData">确认恢复</el-button></div>
              </el-alert>
            </template>
            <template v-if="activeName === 'wxsph'">
              <el-alert type="warning" style="margin-bottom: 10px;"> 
                <div slot="title"> 
                    视频号小店已迁移到微信小店，详见 
                    <el-link 
                      target="_blank"
                      href="https://store.weixin.qq.com/chengzhang/webdoc/wiki/2121/bb4a31143f83be28/growth_center_platform_notice"
                    >
                      关于「视频号小店升级为微信小店」公告
                    </el-link>
                </div>
              </el-alert>
            </template>
            <template v-if="showAutoCreateFormAlert">
              <el-alert type="warning" style="margin-bottom: 10px;"> 
                <div slot="title">
                  <i class="el-icon-warning-outline" style="font-size: 24px;color: #faad14;margin-right:10px;"></i>
                  <span style="color:#070707;">是否自动生成{{ PLATFORM_NAMES[p] }}资料？</span>
                  <el-button type="text" @click="toCreateForm(p)">立即生成</el-button></div>
                <div style="color: #F56C6C;">
                  以提高资料完善效率，{{ PLATFORM_NAMES[p] }}资料已由AI自动生成，资料信息以资参考，如需调整，可自行编辑资料后保存。如需开启自动生成平台资料，请前往 
                  <el-button type="text" @click="toPlatformConf">商品平台配置</el-button> 
                </div>
              </el-alert>
            </template>
            <template v-else-if="isFastCreateDetailInfo">
              <el-alert type="warning" style="margin-bottom: 10px;"> 
                <div slot="title" style="color:#070707;">
                  以提高资料完善效率，{{ PLATFORM_NAMES[p] }}资料已由<span style="color:#faad14;">AI自动生成</span>，资料信息以资参考，如需调整，可自行编辑资料后保存。如需调整配置请前往 
                  <el-button type="text" @click="toPlatformConf">商品平台配置</el-button>
                </div>
              </el-alert>
            </template>
            <ValidationPanel
              v-if="validationReady && (errorDetails.length || filteredSuggestions.length)"
              :errorItems="errorDetails"
              :suggestionItems="filteredSuggestions"
              @scroll-to="handlePanelScroll"
            />
            <component
              v-if="activeName === p && !loading[p] && visible"
              :is="`${p}Form`"
              :ref="`${p}Form`"
              :form="getForm(p)"
              :formData="getForm(p)"
              :rowData="rowData"
              :changeToBase="changeToBase"
              :canPublishPlatform="canPublishPlatform"
              :isDistributor="isDistributor"
              :canEditOuterId="canEditOuterId"
              :publishEntrance="publishEntrance"
              :platform="p"
              :baseItemId="baseItemId"
              :mtRapidType="mtRapidType"
              :isEdit="true"
              :isCanEdit="isCanEdit"
              source="edit_base"
              :openSource="openSource"
              @redirect="method_close"
              @hook:mounted="formMounted"
              @form-validate-detail="handleErrorDetails"
              @form-suggestions="handleSuggestions"
              @setShopCache="fetchInfo">
              <template v-if="p !== 'base' && activeName === p && errMsg" slot="errMsg">
                <div class="err-tips">
                  <el-alert
                    :title="errMsg"
                    type="error">
                  </el-alert>
                </div>
              </template>
            </component>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <div class="drawer-footer">
      <div class="left">
        <!-- 一键翻译 -->
        <CustomTranslateDialog v-if="isKj && activeName !== 'kjBase'" @confirm="handleCustomTranslateConfirm" />
        <template v-if="openSource === 'shopGoods'">
          <el-button type="primary" @click="handleSave" style="padding: 5px 20px;">更新店铺商品</el-button>
        </template>
        <template v-else-if="openSource === 'taskCenter'">
          <template v-if="isCanEdit">
            <el-button type="primary" @click="customSave" style="padding: 5px 20px;">保 存</el-button>
            <el-button @click="() => customSave('publish')">保存并铺货到{{PLATFORM_NAMES[activeName]}}</el-button>
          </template>
          <div v-else style="position: relative;bottom:20px;">
            <el-button @click="visible = false" style="padding: 5px 20px;">关闭</el-button>
          </div>
        </template>
        <template v-else-if="openSource === 'previewPublish'">
          <el-button type="primary" @click="handleSave">预览裂变信息后铺货</el-button>
        </template>
        <template v-else-if="!isFromLog">
          <el-button type="primary" @click="handleSave" style="padding: 5px 20px;">保 存</el-button>
          <el-button v-if="!callbackActiveName"  @click="handleBulkShelves">保存并铺货到平台</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="handleSave" style="padding: 5px 20px;">重新铺货</el-button>
          <el-button @click="handleBack" >返回</el-button>
        </template>
        <el-button v-if="isPublicSourceReport" @click="(event)=>handleSave(event, true)" style="padding: 5px 20px;">重新提报</el-button>
        <!-- <template v-if="hasUnValidFields">
          <span class="error-points-tip">
            <em class="el-icon-error"></em>待完善内容（必填项）：{{unValidCount}}项
          </span>
          <el-link :underline="false" @click="fixedToErrorWrap()">
            快速定位>
          </el-link>
        </template> -->
      </div>
      <div class="right" v-if="isCanEdit">
        <el-button type="primary" v-if="showShelvesBtn" @click="handleBulkShelvesConfig">铺货配置</el-button>
        <span v-if="activeName !== 'base'" style="margin-left: 20px;"> 
          <span style="color: #CCC;">店铺已授权，显示不正确?</span>
          <el-button type="link" icon="el-icon-refresh" @click="refreshShopList">刷新店铺授权状态</el-button>
          <el-button type="primary" @click="handleAuth">店铺授权</el-button>
        </span>
      </div>
    </div>
    </div>
    <ComparePlatform ref="comparePlatform" @abandon="handleAbandon"/>
    <SyncErpSku ref="syncErpSku" @edit="(type,repeatIds, isSkip) => save(type, repeatIds, isSkip)"/>
    <DistributionConfig ref="distributionConfig" :activeName="activeName" />
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
      width="40%"
    >
      <div class="warning-wrap">
        <i class="el-icon-warning"></i>
        <div>
          商品规格未关联ERP商品，加入分销小店失败，解决方案如下:<br/>
          创建同商品编码的ERP商品后，再次保存基础资料，即可建立关联关系。
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import prod_center_dictionary from '../dictionary'
import ComparePlatform from '@/components/prod/center/components/BaseInfoForm/components/comparePlatform.vue'
import {getErpItems, putGoodsBatch} from '@/servers/prod/center'
import SyncErpSku from '@/components/prod/center/components/BaseInfoForm/components/syncErpSku.vue'
import _ from 'lodash'
import DistributionConfig from './DistributionConfig.vue'
import CustomTranslateDialog from './CustomTranslateDialog.vue'
import { getMedicineType} from '@/servers/prod/center/mt.js'

import {
  getPlatformFormComps,
  getLoadingInit,
  getFormInit,
  getPlatformInfoParams,
  PLATFORM,
  PLATFORM_NAMES,
  PLATFORM_CATEGORY,
  KJ_PLATFORM,
  PLATFORM_INFO_PARSE,
  PLATFORM_INFO_API,
  PLATFORM_EDIT_API,
  PLATFORM_EDIT_API2,
} from './EditDialog-init'
import { cachedPlatformSpecInfo, getPlatformCachedSpecInfo, deletePlatformCachedSpecInfo, getFastDetail } from '@/api/prod/center/index'
import { getShopGoodsItemDetail } from '@/api/prod/center/shopGoods'
import { PUHUO_INIT_PLATFORMS_MAP } from '@/dictionary/platforms';
import ValidationPanel from '../components/ValidationPanel.vue';

export default {
  props: {
    smallShopItem: {
      type: Boolean,
      default: false
    },
    isFromLog: { // 是否从铺货日志进入
      type: Boolean,
      default: false
    }

  },
  components: {
    ...getPlatformFormComps(),
    ComparePlatform,
    SyncErpSku,
    DistributionConfig,
    CustomTranslateDialog,
    ValidationPanel
  },
  data() {
    return {
      ...prod_center_dictionary,
      PLATFORM,
      PLATFORM_NAMES,
      visible: false,
      formUpdated: false,
      selectShopList: [],
      loading: getLoadingInit(),
      activeName: PLATFORM[0],
      platformPaneList:[],
      actPlatformCategory:'gn',
      ...getFormInit(),
      openSource:'', // 触发弹窗来源
      baseItemId: null,
      mtRapidType:null,
      id: null,
      callbackActiveName: '',
      errMsg: '',
      rowData: {}, // 外部传入的商品数据
      shops: [],
      shopId: '',
      canPublishPlatform: [], // 允许铺货的平台
      isDistributor:false,
      publishEntrance: 1,
      canEditOuterId: false,
      bulkShelvesFn: null,
      hasUnValidFields: false,
      unValidCount: 0,
      showCachedData: false,
      showCatTip: false,
      cachedPlatformData: null,
      hasSetCachedData: false,
      saveLoading: false,   // 避免重复发起多次保存调用
      platforms: PUHUO_INIT_PLATFORMS_MAP,
      PLATFORM_CATEGORY:PLATFORM_CATEGORY,
      showShelvesBtn: false,
      isPublicSourceReport: false,
      dialogVisible:false,
      isCanEdit:true, // 是否可以编辑
      saveFn:null, // 保存方法
      taskItemsData:null, // AI生图任务数据
      retryFn:null, // AI生图重试方法
      platformCategoryList:[],
      singlePlatformTab:'',
      errorDetails: [],
      suggestionDetails: [],
      validationReady: false, // 校验数据是否已就绪，用于避免 ValidationPanel 闪烁
    }
  },

  provide() {
    return {
      selectShopList: () => this.selectShopList,
      outerId: () => this.rowData?.outerId || '',
      pictureFolderId: () => localStorage.getItem('km_picture_folder_id') || '',
      updatePictureFolderId: (folderId) => { folderId ? localStorage.setItem('km_picture_folder_id', folderId) : localStorage.removeItem('km_picture_folder_id'); },
      // AI生图相关
      aiTaskItemsData: () => this.taskItemsData,
      aiRetryFn: () => this.retryFn,
    };
  },

  watch: {
    activeName(v) {
      this.showShelvesBtn = this.platforms.some(item => item.key === v) && this.$fromGyl
      this.fetchInfo(v)
    },
    visible(v) {
      if (!v) {
        const currentTab = this.$refs[`${this.activeName}Form`][0];
        currentTab && currentTab.removeEventListener && currentTab.removeEventListener();
      }else{
        this.initTabData()
      }
      if(this.prodRePublishRowData || this.displayRePublishData) return;
      v && this.fetchInfo(this.activeName);
    }
  },
  computed: {
     ...mapGetters(["prodRePublishRowData", "displayRePublishData", "shops_authorizedShops","featureCodes"]),
    showAutoCreateFormAlert() {
      const platformData = this[`${this.activeName}Form`] || {}
      return this.FAST_CREATE_PLATFORMS.includes(this.activeName) && !platformData.categoryIds?.length && this.openSource !== 'shopGoods'
    },
    isFastCreateDetailInfo() {
      const platformData = this[`${this.activeName}Form`] || {}
      return platformData.itemSource == 1
    },
    isKj(){ // 是否是跨境平台
      return KJ_PLATFORM.includes(this.activeName)
    },
    filteredSuggestions() {
      if (this.activeName !== 'fxg') return []
      return this.suggestionDetails
    },
  },
  methods: {
    ...mapActions(['clearRePublishRowData', 'clearDisplayRePublishRowData', 'judgeRemovePureItemWhitelist','SetDefaultSearchImageList', 'updateShops']),
     ...mapMutations(['setUpdateIndex']),
    refreshShopList() {
      this.updateShops({configs: {isNeedLoading: true}})
    },
    getForm(p) {
      return this[`${p}Form`]
    },
    handleScroll(){
        const dropdowns = document.querySelectorAll('body>.el-select-dropdown');
        dropdowns.forEach(dropdown => {
            dropdown.style.display = 'none';
        });
    },
    // 提报货源
    async fetch_goodsPut() {
      const params = {
        companyId: this.rowData.companyId,
        baseItemIds: [this.rowData.baseItemId],
      };
      const res = await putGoodsBatch(params);
      if (!res) return;
      this.$message.success("提报成功");
      this.visible = false;
    },

    closeHandle() {
      const forms = Object.keys(getFormInit())
      this.errMsg = '';
      this.canPublishPlatform = [];
      this.shops = []
      this.successCallback = null;
      this.callbackActiveName = '';
      this.selectShopList = [];
      localStorage.removeItem('km_picture_folder_id'); // 清空素材空间记住的文件夹 ID
      forms.forEach(item => {
        this[item] = {}
        this.$refs[item] && this.$refs[item][0] && this.$refs[item][0].clear_specification()
      })
      this.activeName === 'base' && this.$refs.baseForm[0].method_clear()
      if(this.prodRePublishRowData) return;
      if(this.displayRePublishData) return;
      console.log(this.formUpdated, '---this.formUpdated---')
      this.$emit('search', this.formUpdated)
    },
    
    handleClick(v) {
      this.$nextTick(() => {
          const elTabsContent = document.querySelector('.el-drawer__body .el-tabs__content');
          if (elTabsContent) {
              elTabsContent.addEventListener('scroll', this.handleScroll);
          }
      });

      this.saveLoading = false
      this.unValidCount = 0;
      this.errorDetails = [];
      this.suggestionDetails = [];
      this.validationReady = false;
      // 延迟一小段时间后再允许面板显示，确保表单数据已完全加载
      setTimeout(() => {
        this.validationReady = true;
      }, 1500);
    },
    // 在组件销毁时移除滚动监听事件
    beforeDestroy() {
        this.saveLoading = false
        const elTabsContent = document.querySelector('.el-drawer__body .el-tabs__content');
        if (elTabsContent) {
            elTabsContent.removeEventListener('scroll', this.handleScroll);
        }
    },

    handleTabsBeforeLeave(activeName, oldActiveName) {
      const activeForm = this.$refs[`${this.activeName}Form`] ? this.$refs[`${this.activeName}Form`][0] : null;
      if (oldActiveName === 'fxg' && (activeForm && activeForm.method_getSavedCachedData)) {
        const { hasEditFlag, cachedData } = activeForm.method_getSavedCachedData();
        if (!hasEditFlag) {
          return true;
        }
        return new Promise((resolve) => {
          cachedPlatformSpecInfo({
            baseItemId: this.baseItemId,
            platformType: oldActiveName,
            ...cachedData
          }).then(() => {
            this.hasSetCachedData = false;
            resolve();
          }).catch(() => {
            resolve();
          })
        })
      }
      return true;
    },
    method_getCachedData() {
      if (this.activeName !== 'fxg') {
        return false;
      }
      getPlatformCachedSpecInfo({
        baseItemId: this.baseItemId,
        platformType: this.activeName
      }).then((res) => {
        const { result, data } = res;
        if (data && data.otherInfo) {
          this.showCachedData = true;
          this.cachedPlatformData = _.cloneDeep(data);
        } else {
          this.showCachedData = false;
        }
      }).catch(() => {
        this.showCachedData = false;
      })
    },
    method_deleteCachedData() {
      if (this.activeName !== 'fxg') {
        return false;
      }
      deletePlatformCachedSpecInfo({
        baseItemId: this.baseItemId,
        platformType: this.activeName
      }).then(() => {
        this.showCachedData = false;
      });
    },
    handleSetCachedData() {
      const { specJsonStr, skuJsonList, otherInfo } = _.cloneDeep(this.cachedPlatformData);
      const formData = JSON.parse(otherInfo);
      formData.specifications = JSON.parse(specJsonStr);
      formData.skuList = JSON.parse(skuJsonList)
      this.loading['fxg'] = true;
      if (this.$refs[`${this.activeName}Form`][0]) {
        this.$refs[`${this.activeName}Form`][0].method_resetCachedData();
      }
      this.$nextTick(() => {
        this.$set(this, `${this.activeName}Form`, _.cloneDeep(formData));
        this.hasSetCachedData = true;
        this.loading['fxg'] = false;
      })
    },
    async toCreateForm(platform) {
      if(this.$fromGyl){
        this.rowData.baseItemId = this.rowData.itemId;
      };
      const platformType = platform === 'alibaba' ? '1688' : platform;      
      const res = await getFastDetail({baseItemId: this.rowData.baseItemId, platformType })
      if(res.data) {
        this.$set(this, `${platform}Form`, PLATFORM_INFO_PARSE[platform](res.data || {}));
      }
    },
    toPlatformConf() {
      const isDistributor = this.$store.getters.userInfo.loginIdentity == '2';
      this.method_close()
      this.$router.push({
        path: isDistributor ? '/distributor/prod_conf' : '/supplier/prod_conf'
      });
    },
    handleAuth() {
      this.method_close()
      const isDistributor = this.$store.getters.userInfo.loginIdentity == '2';
      let baseURL = isDistributor ? '/distributor' : '/supplier';
      this.$router.push({
        path: `${baseURL}/shopManage`
      });
    },
    changeToBase(operate) {// 切换到基础资料编辑
      this.activeName = 'base';
      this.$nextTick(()=>{
        setTimeout(() => {
          if(operate === 'openGroupImgs' && this.$refs['baseForm']?.length) {
            this.$refs['baseForm'][0].scroll_groupImages_item()
          }
        }, 1000)
      })
    },
    timeErrMsg() {
      const timeId = setTimeout(() => {
        this.errMsg = '';
        clearTimeout(timeId);
      }, 12000);
    },
    // 入口
    async method_open(rowData, {
      shops,
      isDistributor,
      publishEntrance,
      canEditOuterId,
      isPublicSourceReport,
      showSinglePlatformTab,
      isCanEdit = true,
      openSource,
      saveFn,
      taskItemsData,
      retryFn,
    } = {}) {
      this.saveLoading = false
      this.formUpdated = false
      // 如果是从铺货日志进入，则需要获取平台信息
      if(this.isFromLog) {
        rowData.isFromLog = true;
      }
      // 判断是否在移除纯商品白名单
      await this.judgeRemovePureItemWhitelist();

      this.$set(this, 'rowData', rowData);
      let { id, baseItemId, itemId,activeName, successCallback, errMsg, canPublishPlatform, selectShopList } = rowData || {};
      this.selectShopList = selectShopList || [];
      this.canPublishPlatform = canPublishPlatform
      this.baseItemId = itemId ? itemId : baseItemId
      this.id = id
      activeName = activeName === '1688' ? 'alibaba' : activeName
      this.activeName = activeName || 'base';
      if(activeName === 'tm') {
        successCallback = null;
      }
      if (activeName && successCallback) {
        this.callbackActiveName = activeName;
      }
      if(showSinglePlatformTab || activeName){
        this.singlePlatformTab = activeName
      }else{
        this.singlePlatformTab = ''
      }
      this.openSource = openSource || ''
      if(saveFn){
        this.saveFn = saveFn
      }
      if(taskItemsData){
        this.taskItemsData = taskItemsData
      }
      if(retryFn){
        this.retryFn = retryFn
      }
      this.successCallback = successCallback; // 保存成功的回调
      this.visible = true;
      this.isDistributor = isDistributor;
      this.publishEntrance = publishEntrance;
      this.canEditOuterId = canEditOuterId;
      this.isCanEdit = isCanEdit
      if (errMsg) {
        this.errMsg = errMsg;
        this.shops = shops || [] 
      }

      // 打开抽屉弹框是，添加滚动监控
      this.handleClick();

      // isPublicSourceReport: 是否显示重新提报按钮。用于提报货源
      this.isPublicSourceReport = isPublicSourceReport;
    },
    // 获取平台资料入口 店铺商品-编辑平台资料
    async method_open2(rowData,{shops, isDistributor, publishEntrance, canEditOuterId, isPublicSourceReport,openSource,successCallback = null} = {}){
      let {source,userId,numIid,baseItemId,selectShopList} = rowData;
      let activeName = source === '1688' ? 'alibaba' : source;
      this.openSource = openSource
      this.singlePlatformTab = activeName;
      this.saveLoading = false
      this.formUpdated = false
      this.selectShopList = selectShopList || [];
      // 判断是否在移除纯商品白名单
      await this.judgeRemovePureItemWhitelist();
      this.$set(this, 'rowData', rowData);
      this.baseItemId = baseItemId;
      this.activeName = activeName
      this.visible = true;
      this.isDistributor = isDistributor;
      this.publishEntrance = publishEntrance;
      this.canEditOuterId = canEditOuterId;
      let _successCallback = rowData.successCallback || successCallback; // 保存成功的回调
      this.successCallback = _successCallback; // 保存成功的回调
      if (activeName && _successCallback) {
        this.callbackActiveName = activeName;
      }

      // 打开抽屉弹框是，添加滚动监控
      this.handleClick();
    },
    formMounted() {
      // 可能的问题，在错误信息消失后，切换平台资料，进入不了特殊处理模式
      // 可能需要另一个变量记录当前编辑弹窗是特殊处理模式
      if (this.errMsg) {
        this.timeErrMsg();
      }
    },
    method_close() {
      this.visible = false;
    },
    fetchInfo(platform, successCallback) {
      platform = platform || this.activeName
      if((platform === 'tm' && !this.shopId)){
        return false;
      }
      const params = getPlatformInfoParams(this,{isDistributor: this.isDistributor})[platform]
      // params如果是个对象
      if(!params || (typeof params === 'object' && !params.baseItemId)) {
        return;
      }else{
        this.fetch_platformInfo(platform, params, successCallback)
      }
    },

    // 处理搜索图逻辑
    formatSearchData(searchImages, specifications) {
      if (!searchImages || !specifications) return searchImages;
      
      // 获取所有规格值
      const allValues = specifications.reduce((acc, spec) => {
        return acc.concat(spec.values || []);
      }, []);

      // 处理每个搜索图项
      return searchImages.map(searchItem => {
        // 查找匹配的规格值
        const matchedValue = allValues.find(value => value.value == searchItem.colorId);
        if (matchedValue) {
          return {
            ...searchItem,
            imageUrls: searchItem.imageUrls,
            colorId: matchedValue.valueKey
          };
        }
        return searchItem;
      });
    },

    async fetch_platformInfo(platform, params, successCallback) {
      if(this.loading[platform]) return
      this.loading[platform] = true;

      if(['yyjk','fyy'].includes(platform)){
        const resType = await getMedicineType(params)
        if(resType.mtRapidType){
          params.mtRapidType = resType.mtRapidType
          this.mtRapidType = resType.mtRapidType
          localStorage.setItem('mtRapidType',this.mtRapidType,399)
        }
      }
      try {
        let res;
        if(this.openSource === 'shopGoods'){// 获取平台资料
          let {source,shopId,numIid,baseItemId} = this.rowData;
          let _params = {
            platformItemId:baseItemId,
            shopId:shopId,
            platform:source
          }
          res = await getShopGoodsItemDetail(_params)
        }else if(['taskCenter','fissionRePublish'].includes(this.openSource)){
          res = this.rowData
        }else{
          res = await PLATFORM_INFO_API[platform](params,{isDistributor: this.isDistributor})
        }
        const formatSearch = this.formatSearchData(res.searchImages,res.specifications)
        res?.searchImages?.length && this.SetDefaultSearchImageList(formatSearch)
        // 商品长图：后端返回字符串，组件需要数组格式
        if (res?.longImage && typeof res.longImage === 'string') {
          res.longImage = res.longImage ? [res.longImage] : [];
        } else if (!res?.longImage) {
          res.longImage = [];
        }
        if (res) {
            this.$set(this, `${platform}Form`, res);
            let _res = res;
            if (_res instanceof Array) {
              _res = _res[0]
            }
            // 获取已授权店铺的下标
            const authorizedShops = this.shops_authorizedShops(platform)
            const index = authorizedShops?.findIndex(item => {
              return item.id == _res.shopId
            })
            this.setUpdateIndex({index: index== -1 ? 0 : index, platform});
            successCallback && successCallback(_res);
            this.method_getCachedData();
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading[platform] = false
      }
    },
    clearTimeOutSaveLoading() {
      // 为了防止有些平台method_getFormData出现异常没有抛出数据，导致saveLoading一直为true,导致保存点击无效，定时清除saveLoading状态
      setTimeout(() => {
        this.saveLoading = false
      }, 1000)
    },
    handleDialogClose() {
      this.dialogVisible = false;
      // 触发自定义事件，通知对话框已关闭
      this.$emit('dialog-closed');
    },
    // 等待对话框关闭的方法
    waitForDialogClose() {
      return new Promise((resolve) => {
        const checkDialogStatus = () => {
          if (!this.dialogVisible) {
            resolve();
          } else {
            setTimeout(checkDialogStatus, 100);
          }
        };
        
        // 添加一次性监听器，当对话框关闭时解析Promise
        const onDialogClosed = () => {
          this.$off('dialog-closed', onDialogClosed);
          resolve();
        };
        
        this.$on('dialog-closed', onDialogClosed);
        checkDialogStatus();
      });
    },
    async handleSave(e, isPut) {
      if(this.saveLoading) return
      this.clearTimeOutSaveLoading()
      // 重新铺货清除
      if(this.prodRePublishRowData) {
          this.clearRePublishRowData()
      }
      if(this.displayRePublishData) {
         this.clearDisplayRePublishRowData()
      }
      
      const button = e?.path?.find(item => item.tagName === 'BUTTON')
      button && button.blur();
      let res = null;

      let data = await this.$refs[`${this.activeName}Form`][0].method_getFormData();
      if(!data) {
        this.saveLoading = false
        return
      };
      if (Array.isArray(data)) { 
        // 目前只有天猫平台需要，其他平台暂时用不到
        this.shopId = data[0]?.shopId;
      } 
      data.smallShopItem = this.smallShopItem;
      this.saveLoading = true
      if(this.activeName == 'base') {
        const erpRes = await getErpItems(_.cloneDeep(data));
        if(!erpRes) {
          this.saveLoading = false
          return
        };

        // 未绑定erp商家编码，不允许加入分销小店，弹出框提示
        if(!erpRes.allowedJoinXd && data.distributionState==1) { 
          this.dialogVisible = true;
          data.distributionState = 2;
          // 等待对话框关闭后再继续
          await this.waitForDialogClose();
        }

        
        await this.showCompare_for_wxxd(_.cloneDeep(data))
        // 同步资料到系统资料勾选的字段需要比较有没有变化，有变化才显示在弹窗中
        const checkSyncErpSkuList = this.checkSyncErpSku(_.cloneDeep(data));
        if((erpRes.addScmBaseItem.length || (erpRes.updateScmBaseItem.length && checkSyncErpSkuList.length) || erpRes.addScmBaseSku.length || (erpRes.updateScmBaseSku.length && checkSyncErpSkuList.length))) {
          this.$refs.syncErpSku.method_open(erpRes, _.cloneDeep(data), 'save', checkSyncErpSkuList)
          this.saveLoading = false
        } else {
          res = await PLATFORM_EDIT_API[this.activeName](_.cloneDeep(data), true)
          this.saveLoading = false
          if (res) {
            if(isPut){
              this.fetch_goodsPut(); // 重新提报
            }else{
              this.formUpdated = true
              this.$message.success('保存成功')
              if (this.callbackActiveName === this.activeName) {
                this.successCallback && this.successCallback();
                this.callbackActiveName = '';
                this.fetchInfo(this.activeName);
                return
              }
              if(data.canPublishPlatform && data.canPublishPlatform.length) {
                setTimeout(()=> {
                  this.method_showCompare(_.cloneDeep(data))
                }, 1000)
              } else {
                this.fetchInfo(this.activeName)
              }
            }
         }
        }
      } else {
         if(this.openSource === 'shopGoods'){
            const { numIid,shopId,source } = this.rowData
            let expandParams = {
              shopId,
              platform:source,
              platformItemId:numIid,
            }
            res = await PLATFORM_EDIT_API2[this.activeName](_.cloneDeep(data),expandParams)
         }else if(this.openSource === 'fissionRePublish'){ // 商品裂变重新铺货特殊处理下
          res = true
         }else{
          res = await PLATFORM_EDIT_API[this.activeName](_.cloneDeep(data))
         }
          this.saveLoading = false
          if (res) {
            if(isPut){
              this.fetch_goodsPut(); // 重新提报
            }else{
              this.method_deleteCachedData();
              if(!['shopGoods','fissionRePublish'].includes(this.openSource)){
                this.$message.success('保存成功')
              }
              this.formUpdated = true
              if (this.callbackActiveName === this.activeName) {
                this.successCallback && this.successCallback(this.openSource === 'fissionRePublish' ? data : undefined );
                this.callbackActiveName = '';
              }
              if(!this.visible) return 
              !['tm'].includes(this.activeName) && this.fetchInfo(this.activeName)
              this.$refs[`${this.activeName}Form`][0].method_saveSuccess && this.$refs[`${this.activeName}Form`][0].method_saveSuccess();
            }
          }
      }

      if(this.isFromLog) {
        this.visible = false;
      }
    },

    async save(type, repeatIds, isSkip) {
      if(this.saveLoading) return
      this.clearTimeOutSaveLoading()
      let res = null;
      let data = await this.$refs[`${this.activeName}Form`][0].method_getFormData();
      if(!data) {
        this.saveLoading = false
        return
      };
      if (Array.isArray(data)) { 
        // 目前只有天猫平台需要，其他平台暂时用不到
        this.shopId = data[0]?.shopId;
      } 
      data.smallShopItem = this.smallShopItem;
      data.repeatOuterIds = repeatIds ? repeatIds : [];
      this.saveLoading = true;
      //执行跳过同步时，不执行新增ERP商品逻辑，仅保存快麦通商品资料
      data.skipAddItemToErp = isSkip;
      
      res = await PLATFORM_EDIT_API[this.activeName](_.cloneDeep(data))
      this.saveLoading = false
      if(!res) return;
      if(type == 'save') {
        this.formUpdated = true
        this.$message.success('保存成功')
        this.method_deleteCachedData();
        if (this.callbackActiveName === this.activeName) {
          this.successCallback && this.successCallback();
          this.callbackActiveName = '';
          this.fetchInfo(this.activeName);
          return
        }
        if(data.canPublishPlatform && data.canPublishPlatform.length) {
          setTimeout(()=> {
            this.method_showCompare(_.cloneDeep(data))
          }, 1000)
        } else {
          this.fetchInfo(this.activeName)
        }
      } else {
        if (this.callbackActiveName === this.activeName) {
          this.successCallback && this.successCallback();
          this.callbackActiveName = '';
        }
        this.bulkShelvesFn = (data)=> {
          this.$emit('bulkShelves',_.cloneDeep(data), this.activeName);
        }
        let isShow = false, filedNameList = [];
        filedNameList = this.get_compareFormData(_.cloneDeep(data));
        isShow = filedNameList.some(item => item.value);
        if(data.canPublishPlatform && data.canPublishPlatform.length && isShow) {
          this.$refs.comparePlatform.method_open(filedNameList, data.canPublishPlatform, data.baseItemId);
        } else {
          this.visible = false;
          this.fetchInfo(this.activeName, this.bulkShelvesFn);
          this.bulkShelvesFn = null;
        }
      }
    },
    async customSave(type){
      if(this.saveFn){
        let data = await this.$refs[`${this.activeName}Form`][0].method_getFormData();
        if(data){
          this.saveFn(data,type,() => {
            this.visible = false;
          })
        }
      }
    },
    handleAbandon() {
      if(this.bulkShelvesFn) {
        this.visible = false;
      }
      this.fetchInfo(this.activeName, this.bulkShelvesFn);
      this.bulkShelvesFn = null;
    },
    // check 是否显示同步弹窗
    checkSyncErpSku(data) {
      const syncErpSkuObj = this.compareSyncErpSku(data);
      const syncContent = data.syncContent;
      const _syncContent =  syncContent.filter(item => {
        return syncErpSkuObj[item]
      })
      return _syncContent
    },
    // 判断同步资料到系统资料的字段是否改变
    compareSyncErpSku(data) {
      const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
      let SyncErpSkuObj = {
        'title': false,
        'mainImages': false,
        'skuOuterId': false,
        'imageUrl': false,
        'weight': false,
        'salesPrice': false,
        'purchasePrice': false,
        'skuSpecifications': false,
        'cgSupplierId': false,
        'skuList': false,
      }
      // 商品名称
      if(origin_form.title !== data.title) {
        SyncErpSkuObj.title = true
      }
      // 商品主图
      if(!this.compareMainImages(origin_form.mainImages, data.mainImages)){
        SyncErpSkuObj.mainImages = true
      }
      // 非纯商品
      if(!data.pureType) {
         // 商品规格
        if(!this.compareSpecifications(origin_form.specifications, data.specifications)) {
          SyncErpSkuObj.skuSpecifications = true
        }
        // 规格明细里的字段变更
        if (!this.compareSkuList(origin_form.skuList, data.skuList)) {
          SyncErpSkuObj.skuList = true
        }
        if(origin_form.skuList?.length !== data.skuList?.length) {
          SyncErpSkuObj.skuOuterId = true;
          SyncErpSkuObj.imageUrl = true;
          SyncErpSkuObj.weight = true;
          SyncErpSkuObj.salesPrice = true;
          SyncErpSkuObj.purchasePrice = true;
        } else {
          let data_skuListObj = {};
          data.skuList.forEach(sku => {
            data_skuListObj[sku.id] = {
              ...sku
            }
          })
          origin_form.skuList.forEach(item => {
            if(data_skuListObj[item.id]) {
              if(!item.skuOuterId && !data_skuListObj[item.id].skuOuterId) {
                SyncErpSkuObj.skuOuterId = false;
              } else{
                if(item.skuOuterId !== data_skuListObj[item.id].skuOuterId) {
                  SyncErpSkuObj.skuOuterId = true;
                }
              }
              if(!item.imageUrl && !data_skuListObj[item.id].imageUrl){
                SyncErpSkuObj.imageUrl = false;
              } else{
                if(item.imageUrl !== data_skuListObj[item.id].imageUrl) {
                  SyncErpSkuObj.imageUrl = true;
                }
              }
              if(!item.weight && !data_skuListObj[item.id].weight) {
                SyncErpSkuObj.weight = false;
              } else {
                if(item.weight !== data_skuListObj[item.id].weight) {
                  SyncErpSkuObj.weight = true;
                }
              }
              if(!item.salesPrice && !data_skuListObj[item.id].salesPrice) {
                 SyncErpSkuObj.salesPrice = false;
              } else {
                if(item.salesPrice !== data_skuListObj[item.id].salesPrice) {
                  SyncErpSkuObj.salesPrice = true;
                }
              }
              if(!item.purchasePrice && !data_skuListObj[item.id].purchasePrice) {
                SyncErpSkuObj.purchasePrice = false;
              } else {
                 if(item.purchasePrice !== data_skuListObj[item.id].purchasePrice) {
                  SyncErpSkuObj.purchasePrice = true;
                }
              }
            } else {
              SyncErpSkuObj.skuOuterId = true;
              SyncErpSkuObj.imageUrl = true;
              SyncErpSkuObj.weight = true;
              SyncErpSkuObj.salesPrice = true;
              SyncErpSkuObj.purchasePrice = true;
              return
            }
          }) 
        }
      } else {
        SyncErpSkuObj.skuOuterId = false;
        SyncErpSkuObj.skuSpecifications = false;
        SyncErpSkuObj.imageUrl = false;
        // 重量
        if(!origin_form.weight && !data.weight) {
          SyncErpSkuObj.weight = false
        } else{
          if(origin_form.weight !== data.weight) {
            SyncErpSkuObj.weight = true
          }
        }
        // 销售价
        if(!origin_form.purePrice && !data.purePrice) {
          SyncErpSkuObj.salesPrice = false;
        } else {
          if(origin_form.purePrice !== data.purePrice) {
            SyncErpSkuObj.salesPrice = true
          }
        }
        // 成本价
        if(!origin_form.purchasePrice && !data.purchasePrice) {
          SyncErpSkuObj.purchasePrice = false
        } else {
          if(origin_form.purchasePrice !== data.purchasePrice) {
            SyncErpSkuObj.purchasePrice = true
          }
        }
      }
      // 商品供销商
      if(!origin_form.itemSupplier && !data.itemSupplier) {
        SyncErpSkuObj.cgSupplierId = false
      } else {
        if(origin_form.itemSupplier?.id !== data.itemSupplier?.id) {
          SyncErpSkuObj.cgSupplierId = true
        }
      }
      return SyncErpSkuObj;
    },
     // 检测3:4主图变化
    detectMainImages34Change(originForm, currentData) {
      const SUPPORT_PLATFORMS = ['fxg', 'tm', 'tb', 'kuaishou']
      const isSupport = currentData.canPublishPlatform.some(platform => SUPPORT_PLATFORMS.includes(platform));
      const hasImage34Change = !this.compareMainImages(originForm.mainImages34, currentData.mainImages34);

      return hasImage34Change && isSupport;
    },
    // 检测规格变化
    detectSpecificationsChange(originForm, currentData) {
      const originSpecs = this.processSpecImages(originForm.specifications);
      const currentSpecs = this.processSpecImages(_.cloneDeep(currentData.specifications));
      return !this.compareSpecifications(originSpecs, currentSpecs);
    },
    // 检测视频变化
    detectVideoChange(originForm, currentData) {
      const SUPPORT_PLATFORMS = ['fxg', 'pdd', 'tb', 'tm','wxsph', 'kuaishou']
      const isSupport = currentData.canPublishPlatform.some(platform => SUPPORT_PLATFORMS.includes(platform));
      if (!isSupport || !currentData.videoList?.length) return false;
      const VIDEO_RATIOS = ['1:1', '3:4', '16:9', '9:16']
      const currentVideos = VIDEO_RATIOS.map(ratio => currentData.videoList.find(item => item && item.videoRatio === ratio)?.originUrl || '').join('');;
      return originForm.videos !== currentVideos;
    },
    compareDescription(originForm, currentData) {
      const SUPPORT_PLATFORMS = ['xhs']
      const isSupport = currentData.canPublishPlatform.some(platform => SUPPORT_PLATFORMS.includes(platform));
      return (originForm.description || '') !== (currentData.description || '') && isSupport;
    },

    compareLongImage(originForm, currentData) {
      const SUPPORT_PLATFORMS = ['pdd', 'tb', 'tm']
      const isSupport = currentData.canPublishPlatform.some(platform => SUPPORT_PLATFORMS.includes(platform));
      return (originForm.longImage || '') !== (currentData.longImage || '') && isSupport;
    },
    detectChanges(originForm, currentData) {
      const changes = {
        title: originForm.title !== currentData.title,
        mainImages: !this.compareMainImages(originForm.mainImages, currentData.mainImages),
        mainImages34: this.detectMainImages34Change(originForm, currentData),
        whiteBackGroundPic: !this.compareMainImages(originForm.whiteBackGroundPic, currentData.whiteBackGroundPic),
        longImage: this.compareLongImage(originForm, currentData),
        detailImages:  !this.compareMainImages(originForm.detailImages, currentData.detailImages),
        specifications: this.detectSpecificationsChange(originForm, currentData),
        videoInfo: this.detectVideoChange(originForm, currentData),
        description: this.compareDescription(originForm, currentData),
      };
      return changes;
    },
    get_compareFormData(data) {
      const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
      const changes = this.detectChanges(origin_form, data);
      let result = [{
          name: '商品名称',
          value: changes.title,
          key: 'title'
        },
        {
          name: '商品主图',
          value: changes.mainImages,
          key: 'mainImages'
        },
        {
          name: '3:4主图',
          value: changes.mainImages34,
          key: 'mainImages34'
        },
        {
          name: '白底图',
          value: changes.whiteBackGroundPic,
          key: 'whiteBackGroundPic'
        },
        {
          name: '商品长图',
          value: changes.longImage,
          key: 'longImage'
        },
        {
          name: '商品规格',
          value: changes.specifications,
          key: 'specifications'
        },
        {
          name: '商品详情图',
          value: changes.detailImages,
          key: 'detailImages'
        },
        { 
          name: '视频(按照上传顺序第一个视频同步)',
          value: changes.videoInfo,
          key: 'videoInfo'
        },
        { 
          name: '商品描述',
          value: changes.description,
          key: 'description'
        }
      ];
      return result;
    },
    processSpecImages(specs) {
      return specs.map(s => {
        s.values.forEach(v => {
          delete v.imageUrl
        })
        return s
      })
    },

    get_compareFormData_specification(data) {
      const origin_form = JSON.parse(localStorage.getItem('_origin_form'));
      let isChangeSpecifications = false;
      if(!this.compareSpecifications(origin_form.specifications, data.specifications) && data.distributionState == 1) {
        isChangeSpecifications = true
      }
      let result = [
        {
          name: '商品规格',
          value: isChangeSpecifications,
          key: 'specifications'
        }
      ];
      return result;
    },
    // .对于加入分销小店的商品，变更基础资料规格时，保存资料时，需提示
    showCompare_for_wxxd(data){
      const filedNameList = this.get_compareFormData_specification(data);
      const isShow = filedNameList.some(item => item.key == "specifications" && item.value);
      return new Promise((resolve, reject) => {
        if(isShow){
          this.$confirm("商品已加入分销小店，规格明细已变更，保存商品后，将变更关联商品供分销关系，可能导致分销商无法推单，是否确认保存商品资料？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }).then(() => {
                  resolve(true)
                }).catch(()=>{
                  reject()
                });
          } else {
            resolve()
          }
      })
    },
    method_showCompare(data) {
      const filedNameList = this.get_compareFormData(data);
      const isShow = filedNameList.some(item => item.value);
      if(isShow) {
        this.$refs.comparePlatform.method_open(filedNameList, data.canPublishPlatform, data.baseItemId);
      } else {
        this.fetchInfo(this.activeName);
      }
    },
    // 判断主图是否相等，判断商品详情图是否相等
    compareMainImages(list1,list2){
      if(list1.length !== list2.length) {
        return false
      }
      return list1.every((item, index) => {
        if(item === list2[index]){
          return true
        }
        return false
      })
    },
    // 判断规格是否相等
    compareSpecifications(a,b) {
      if(a === b) {
        return true
      }
      if (typeof a !== typeof b || a === null || b === null) {
        return false;
      }
      if (Array.isArray(a)) {
        if (!Array.isArray(b)) {
            return false;
        }
        return this.compareArray(a, b);
      }
      if (typeof a === "object") {
          return this.compareObject(a, b);
      }
      return false
    },
    // 判断规格明细是否相通
    compareSkuList(originSkuList = [], currentSkuList = [], watchingFields) {
      watchingFields = watchingFields || ['weight', 'stock', 'salesPrice', 'marketPrice']
      if (originSkuList.length !== currentSkuList.length) {
        return false;
      }
      // 需要判断的字段列表
      let allFieldUnChanged = true;
      for (let i = 0; i < watchingFields.length; i ++) {
        const field = watchingFields[i];
        for (let j = 0; j < originSkuList.length; j ++) {
          const _skuid = originSkuList[j]._skuid
          const findItem = currentSkuList.find(item => item._skuid === _skuid) || {}
          if (originSkuList[j][field] !== findItem[field]) {
            allFieldUnChanged = false
            break;
          }
        }
        if (allFieldUnChanged === false) {
          break;
        }
      }
      return allFieldUnChanged;
    },
    // 判断两个对象是否相等
    compareObject(obj1,obj2) {
      const keya = Object.keys(obj1);
      const keyb = Object.keys(obj2);
      if(keya.length !== keyb.length) {
        return false
      }
      return keya.every(key => {
          if (!this.compareSpecifications(obj1[key], obj2[key])) {
              return false;
          }
          return true;
      });
    },
    // 判断两个数组是否相等
    compareArray(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const length = arr1.length;
      for (let i = 0; i < length; i++) {
        if (!this.compareSpecifications(arr1[i], arr2[i])) {
            return false;
        }
      }
      return true;
    },
    handleBack() {
      this.visible = false;
    },
    async handleBulkShelves() {
      if(this.saveLoading) return
      this.clearTimeOutSaveLoading()

      if(this.prodRePublishRowData) {
          this.clearRePublishRowData()
      }
      if(this.displayRePublishData) {
         this.clearDisplayRePublishRowData()
      }
      let res = null;
      let data = await this.$refs[`${this.activeName}Form`][0].method_getFormData()
      if(!data) {
        this.saveLoading = false
        return 
      };
      if (Array.isArray(data)) { 
        // 目前只有天猫平台需要，其他平台暂时用不到
        this.shopId = data[0]?.shopId;
      } 
      data.smallShopItem = this.smallShopItem;
      this.saveLoading = true
      if(this.activeName == 'base') {
        const erpRes = await getErpItems(_.cloneDeep(data));
        if(!erpRes) {
          this.saveLoading = false
          return 
        };
        // 未绑定erp商家编码，不允许加入分销小店，弹出框提示
        if(!erpRes.allowedJoinXd && data.distributionState==1) { 
          this.dialogVisible = true;
          data.distributionState = 2;
          // 等待对话框关闭后再继续
          await this.waitForDialogClose();
        }
        // 同步资料到系统资料勾选的字段需要比较有没有变化，有变化才显示在弹窗中
        const checkSyncErpSkuList = this.checkSyncErpSku(_.cloneDeep(data));
        if(erpRes.addScmBaseItem.length || (erpRes.updateScmBaseItem.length && checkSyncErpSkuList.length) || erpRes.addScmBaseSku.length || (erpRes.updateScmBaseSku.length && checkSyncErpSkuList.length)) {
          this.$refs.syncErpSku.method_open(erpRes, _.cloneDeep(data), 'bulkShelves', checkSyncErpSkuList)
          this.saveLoading = false
        } else {
          res = await PLATFORM_EDIT_API[this.activeName](_.cloneDeep(data), true)
          this.saveLoading = false
           if(res) {
            this.formUpdated = true
            this.method_deleteCachedData();
            if (this.callbackActiveName === this.activeName) {
              this.successCallback && this.successCallback();
              this.callbackActiveName = '';
            }
            this.bulkShelvesFn = (data)=> {
              this.$emit('bulkShelves',_.cloneDeep(data), this.activeName);
            }
            let isShow = false, filedNameList = [];
            filedNameList = this.get_compareFormData(data);
            isShow = filedNameList.some(item => item.value);
            if(data.canPublishPlatform && data.canPublishPlatform.length && isShow) {
              this.$refs.comparePlatform.method_open(filedNameList, data.canPublishPlatform, data.baseItemId);
            } else {
              this.visible = false;
              this.fetchInfo(this.activeName, this.bulkShelvesFn);
              this.bulkShelvesFn = null;
            }
          }
        }
      } else {
          this.clearTimeOutSaveLoading()
          const res = await PLATFORM_EDIT_API[this.activeName](_.cloneDeep(data))
          this.saveLoading = false
          if(res) {
            this.formUpdated = true
            this.method_deleteCachedData();
            if (this.callbackActiveName === this.activeName) {
              this.successCallback && this.successCallback();
              this.callbackActiveName = '';
            }
            this.bulkShelvesFn = (data)=> {
              this.$emit('bulkShelves',_.cloneDeep(data), this.activeName);
            }
            this.visible = false;
            this.fetchInfo(this.activeName, this.bulkShelvesFn);
            this.bulkShelvesFn = null;
          }
      }
    },
    /**
     * 表单校验
     * @param {*} valid 
     */
    // formValidCallback(valid) {
    //   if (valid === true) {
    //     this.hasUnValidFields = false;
    //     this.unValidCount = 0;
    //   } else {
    //     this.hasUnValidFields = true;
    //     this.unValidCount = valid;
    //   }
    // },
    handleErrorDetails(details) {
      this.errorDetails = details || []
    },
    handleSuggestions(suggestions) {
      this.suggestionDetails = suggestions || []
    },
    handlePanelScroll(item) {
      const currentForm = this.$refs[`${this.activeName}Form`][0]
      if (!currentForm || !currentForm.$refs.form) return
      const formEl = currentForm.$refs.form.$el
      let target = null
      // 1. 错误项：通过 errorIndex 直接取 DOM 中的错误元素
      if (item.errorIndex != null) {
        target = formEl.querySelectorAll('.el-form-item__error')[item.errorIndex]
      }
      // 2. 建议优化项：通过 prop 查找对应 el-form-item，找不到则通过 label 文本匹配
      if (!target && item.prop) {
        target = formEl.querySelector(`[prop="${item.prop}"]`)
      }
      if (!target && item.label) {
        const allLabels = formEl.querySelectorAll('.el-form-item__label')
        for (const labelEl of allLabels) {
          const text = labelEl.textContent.replace(/[:：]/g, '').trim()
          if (text === item.label) {
            target = labelEl.closest('.el-form-item')
            break
          }
        }
      }
      if (!target) return
      // 查找 tabContent（和 fixedToErrorWrap 相同的遍历逻辑）
      let tabContent = null
      let t = formEl
      while (!tabContent) {
        if (t && t.className.split(' ').includes('el-tabs')) {
          tabContent = t
        } else if (t.parentElement && t.parentElement.className.split(' ').includes('el-tabs__content')) {
          tabContent = t.parentElement
        } else {
          t = t.parentElement
        }
      }
      if (!tabContent) {
        tabContent = document.querySelector('#prod-center-edit-dialog .subTab > .el-tabs__content')
      }
      if (!tabContent) return
      // 计算 offset 并滚动
      let totalTop = 0
      let par = target.offsetParent
      totalTop += target.offsetTop
      while (par && par !== tabContent) {
        totalTop += par.offsetTop
        par = par.offsetParent
      }
      tabContent.scrollTo(0, totalTop - 200)
    },
    fixedToErrorWrap() {
      const currentForm = this.$refs[`${this.activeName}Form`][0];
      if (currentForm) {
        currentForm.fixedToErrorWrap();
      }
    },
    // 铺货配置
    handleBulkShelvesConfig() {
      this.$refs.distributionConfig.method_open()
    },
    // 自定义翻译确认回调
    handleCustomTranslateConfirm(fields,translateFn) {
      this.$refs[`${this.activeName}Form`][0]?.translateData(fields,translateFn);
    },
    // 国内/跨境切换
    platformCategoryTabClick($el){
      let key = $el.$options.propsData.name
      let list = this.PLATFORM_CATEGORY[key].platform
      this.activeName = list[0];
      this.platformPaneList = list
    },
    initTabData(){
      let platformCategoryList = Object.keys(PLATFORM_CATEGORY)
      let platformPaneList = []
      let platformCategory = 'gn'
      if(this.isFromLog){
        platformPaneList = [this.activeName]
      }
      if(this.singlePlatformTab){// 打开指定平台处理逻辑
        this.activeName = this.singlePlatformTab
        platformPaneList = [this.singlePlatformTab];
        // 编辑指定平台时，处理第一级tab的回显逻辑，根据当前平台所在的分类自动选中【商品编辑】还是【跨境商品编辑】
        for(let key in PLATFORM_CATEGORY){
          let platform = PLATFORM_CATEGORY[key].platform
          if(platform.includes(this.singlePlatformTab)){
            platformCategory = key;
            // platformCategoryList = [key] // 只展示指定平台对应的上一级tab，其他tab不显示  
            break;
          }
        }
      }else{
        let arr = PLATFORM_CATEGORY[platformCategory].platform
        platformPaneList = arr
        this.activeName = this.activeName || arr[0]
      }
      this.actPlatformCategory = platformCategory
      this.platformCategoryList = platformCategoryList
      this.platformPaneList = platformPaneList
    },
    // 控制能否编辑商品分类
    disabledLlatformCategory(type){
        if(this.singlePlatformTab){ // 编辑指定平台时，不属于当前平台分类下的tab置灰不可编辑
          let platforms = this.PLATFORM_CATEGORY[type].platform
          return !platforms.includes(this.singlePlatformTab)
        }
        if(type === 'gn'){
          return false
        }else if(type === 'kj'){
          let featureCodes = this.featureCodes || [];
          let isPermission = featureCodes.includes('crossBorderProductListing'); // 是否开通编辑跨境商品权限
          return !isPermission
        }
        return false
    }
  }
} 
</script>

<style lang="scss" scoped>
.edit-drawer {
  // left: 180px;
  // top: 50px;
  ::v-deep .prod-custom-loading {
    background-color: rgba(255, 255, 255, 0.8) !important;
    .el-loading-spinner {
      top: 300px;
      .el-icon-loading {
        color: #999;
      }
    }
  }
  ::v-deep .el-table th>.cell {
    line-height: normal;
    height: unset;
  }
  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 700;
    color: #3e4144;
  }
  ::v-deep .el-drawer__body {
    padding: 10px 20px;
   
  }
  .drawer-footer {
    padding: 30px 10px;
    .left {
      float: left;
      padding-left: 130px;
    }
    .right {
      float: right;
    }
    .error-points-tip {
      margin-left: 20px;
      color: #f62525;
      vertical-align: middle;
    }
  }
  ::v-deep .el-tabs__header {
    z-index: 99;
    background-color: hsla(0,0%,100%,.8);
  }
  ::v-deep .el-tabs__item {
    height: 46px;
    line-height: 46px;
    padding: 0 10px;
  }
  .subTab {
    ::v-deep > .el-tabs__content {
      padding-right: 15px;
      padding-bottom: 20px;
      height: calc(100vh - 250px);
      overflow: auto;
    }
  }
  // &.wd{
  //   ::v-deep .el-tabs__content {
  //     height: calc(100vh - 170px);
  //   }
  // }
  ::v-deep .el-tabs__nav-wrap {
    padding-left: 15px;
  }

  .el-tab-pane {
    min-height: 20vh;
  }
}
.large-btn {
  padding: 0;
  width: 88px;
  border-radius: 2px;
}
.err-tips {
  margin-bottom: 10px;
}
::v-deep .el-dialog__body{
  min-height: 100px !important;
  .warning-wrap {
    margin: 10px 0 0 4px; 
    display: flex; 
    line-height: 30px;
    font-size: 13px;
    .el-icon-warning{
      color: #e6a23c; 
      font-size: 16px; 
      margin: 6px 4px 0 0;
    }
  }
}
</style>